import { CATEGORIES } from "./CATEGORIES";

export const EVENTS = {
  COMMON: {
    OPEN_EXTERNAL_LINK: {
      category: CATEGORIES.COMMON,
      action: "Open External Link",
    },
    PLAY_VIDEO: {
      category: CATEGORIES.COMMON,
      action: "Play Video",
    },
    AUTOFILL_CONTACT_INFO: {
      category: CATEGORIES.COMMON,
      action: "Autofill Contact Info",
    },
    AUTOFILL_VEHICLE_DATA: {
      category: CATEGORIES.COMMON,
      action: "Autofill Vehicle Data",
    },
  },
  SIGNING: {
    CANCEL: {
      category: CATEGORIES.SIGNING,
      action: "Cancel",
    },
    SELECT_SIGNING_METHOD: {
      category: CATEGORIES.SIGNING,
      action: "Select Signing Method",
    },
    OPEN: {
      category: CATEGORIES.SIGNING,
      action: "Open",
    },
    COMPLETED: {
      category: CATEGORIES.SIGNING,
      action: "Completed",
    },
  },
  FOOTER: {
    EMAIL_CUSTOMER_SERVICE: {
      category: CATEGORIES.FOOTER,
      action: "Email Customer Service",
    },
  },
  LANDING_PAGE: {
    CREATE_REPORT: {
      category: CATEGORIES.LANDING_PAGE,
      action: "Create Report",
    },
    CANCEL_CREATE_REPORT: {
      category: CATEGORIES.LANDING_PAGE,
      action: "Create Report",
    },
    GO_TO_CREATE_REPORT: {
      category: CATEGORIES.LANDING_PAGE,
      action: "Access Create Report Page",
    },
    OPEN_SAVED_REPORT: {
      category: CATEGORIES.LANDING_PAGE,
      action: "Open Saved Report",
    },
    SEE_MORE: {
      category: CATEGORIES.LANDING_PAGE,
      action: "Expand List of Saved Reports",
    },
    OPEN_QUESTION: {
      category: CATEGORIES.LANDING_PAGE,
      action: "Open Question",
    },
    OPEN_SHUTDOWN_FAQ_QUESTION: {
      category: CATEGORIES.LANDING_PAGE,
      action: "Open Shutdown Faq Question",
    },
  },
  CONFIRMATION_PAGE: {
    DOWNLOAD_ZIP: {
      category: CATEGORIES.CONFIRMATION_PAGE,
      action: "Download ZIP",
    },
  },
  FAQ: {
    FILTER: {
      category: CATEGORIES.FAQ_PAGE,
      action: "Filter",
    },
    OPEN_QUESTION: {
      category: CATEGORIES.FAQ_PAGE,
      action: "Open Question",
    },
    EMAIL_CUSTOMER_SERVICE: {
      category: CATEGORIES.FAQ_PAGE,
      action: "Email Customer Service",
    },
  },
  PRIVACY_PAGE: {
    EMAIL_DELETE_DATA: {
      category: CATEGORIES.PRIVACY_PAGE,
      action: "Request deletion of data",
    },
  },
  ATTACHMENTS: {
    REMOVE: {
      category: CATEGORIES.ATTACHMENTS_PAGE,
      action: "Remove",
    },
    DROP: {
      category: CATEGORIES.ATTACHMENTS_PAGE,
      action: "Drag-and-Drop to Upload",
    },
    UPLOAD: {
      category: CATEGORIES.ATTACHMENTS_PAGE,
      action: "Click to Upload",
    },
    DOWNLOAD_ZIP: {
      category: CATEGORIES.ATTACHMENTS_PAGE,
      action: "Download Zip",
    },
  },
  REPORT_UPDATES_MODAL: {
    OPEN: {
      category: CATEGORIES.REPORT_UPDATES_MODAL,
      action: "Open",
    },
    CLOSE: {
      category: CATEGORIES.REPORT_UPDATES_MODAL,
      action: "Ok",
    },
    DISMISS: {
      category: CATEGORIES.REPORT_UPDATES_MODAL,
      action: "Dismiss",
    },
  },
  PAGE_TWO: {
    SAVE: {
      category: CATEGORIES.PAGE_TWO,
      action: "Save",
    },
  },
  BECOME_MEMBER_POPUP: {
    OPEN: {
      category: CATEGORIES.BECOME_MEMBER_POPUP,
      action: "Open",
    },
    OPEN_AUTOMATICALLY: {
      category: CATEGORIES.BECOME_MEMBER_POPUP,
      action: "Open Automatically",
    },
    DISMISS: {
      category: CATEGORIES.BECOME_MEMBER_POPUP,
      action: "Dismiss",
    },
    DECLINE: {
      category: CATEGORIES.BECOME_MEMBER_POPUP,
      action: "Decline",
    },
    BECOME_MEMBER: {
      category: CATEGORIES.BECOME_MEMBER_POPUP,
      action: "Become Member",
    },
    LOG_IN: {
      category: CATEGORIES.BECOME_MEMBER_POPUP,
      action: "Log In",
    },
  },
  HEADER: {
    BECOME_MEMBER: {
      category: CATEGORIES.HEADER,
      action: "Become Member",
    },
    LOG_IN: {
      category: CATEGORIES.HEADER,
      action: "Log In",
    },
    LOG_OUT: {
      category: CATEGORIES.HEADER,
      action: "Log Out",
    },
    PREVIEW: {
      category: CATEGORIES.HEADER,
      action: "Open Preview",
    },
    FAQ: {
      category: CATEGORIES.HEADER,
      action: "Open FAQ",
    },
  },
};
